import { useT } from "../../i18n";

export const SocialProof = () => {
  const t = useT();
  return (
    <section id="results" className="sp-section" data-testid="section-results">
      <div className="sp-container">
        <div className="sp-reveal">
          <span className="sp-eyebrow">{t.socialProof.eyebrow}</span>
          <h2 className="sp-title">
            {t.socialProof.titlePre}
            <em>{t.socialProof.titleEm}</em>
          </h2>
        </div>

        <div className="sp-proof-layout sp-reveal">
          <div className="sp-proof-card">
            <p>{t.socialProof.quote1}</p>
            <span className="sp-proof-attribution">{t.socialProof.attr1}</span>
          </div>

          <div className="sp-proof-metric">
            <span className="sp-big-num">{t.socialProof.metric1Num}</span>
            <span className="sp-big-label">{t.socialProof.metric1Label}</span>
          </div>

          <div className="sp-proof-metric">
            <span className="sp-big-num">{t.socialProof.metric2Num}</span>
            <span className="sp-big-label">{t.socialProof.metric2Label}</span>
          </div>

          <div className="sp-proof-card">
            <p>{t.socialProof.quote2}</p>
            <span className="sp-proof-attribution">{t.socialProof.attr2}</span>
          </div>
        </div>
      </div>
    </section>
  );
};
